import Stack from "@mui/material/Stack";

import { ExecutionPanelConversation } from "./ExecutionPanelConversation";
import { useExecutionPanelContext } from "./ExecutionPanelContext";
import { AiDisclaimer } from "@src/features/ai/components/WorkflowEditor/execution/components/AiDisclaimer";
import { UserInput } from "@src/features/ai/components/WorkflowEditor/execution/input/UserInput";
import { DropZoneRef } from "@src/features/ai/components/WorkflowEditor/execution/types";

/**
 * The conversation over its bottom dock, laid out as Figma's "chat-panel"
 * (15083:18901): the messages take the height left over and the dock sits at
 * the bottom, 32px clear of the last message whatever the dock holds — the
 * composer alone, or a question, combobox or file card above it — with 8px
 * between each thing the dock stacks.
 */
export const ExecutionPanelChat = () => {
  const { getSlot, dropZoneRef, compact } = useExecutionPanelContext();
  return (
    <Stack
      ref={dropZoneRef as DropZoneRef<HTMLDivElement>}
      sx={{
        position: "relative",
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {getSlot("chatHeader")}
      <ExecutionPanelConversation />
      {getSlot(
        "chatFooter",
        <Stack
          data-testid="execution-panel-dock"
          sx={{ flexShrink: 0, gap: 2, mt: compact ? 3 : 8 }}
        >
          {getSlot("chatBanner")}
          {getSlot("userInput", <UserInput />)}
          {getSlot("disclaimer", <AiDisclaimer />)}
        </Stack>
      )}
    </Stack>
  );
};
